import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import HelpDialogLayout, {
  HelpDialogButton,
  HelpDialogLayoutProps,
} from "./HelpDialogLayout";

export interface JudgementCriteriaDialogProps
  extends Omit<HelpDialogLayoutProps, "children" | "title"> {}

export function JudgementCriteriaDialog(props: JudgementCriteriaDialogProps) {
  const data = [
    {
      judge: "A 睡眠課題なし",
      description: "健やかな睡眠で、全く課題はありません。",
    },
    {
      judge: "B 大きな課題なし",
      description:
        "一部改善の余地がある日もありますが、大きな課題はありません。",
    },
    {
      judge: "C 改善を推奨",
      description: "睡眠の長さ・質・リズムいずれかの改善が推奨されます。",
    },
    {
      judge: "D 改善を要する",
      description: "睡眠の長さ・質・リズムいずれかの改善が必要とされます。",
    },
    {
      judge: "E 受診を推奨",
      description:
        "睡眠時無呼吸症候群もしくは不眠症のリスクがあり、医療機関への受診を推奨します。",
    },
    {
      judge: "- 判定不能",
      description: "測定データが不足しているため判定できません。",
    },
  ] as const;
  return (
    <HelpDialogLayout title="判定基準" {...props}>
      <Stack gap={6}>
        <TableContainer
          sx={{
            borderRadius: 0,
            "& th": {
              px: 0,
              py: 2,
              width: "50%",
              borderTop: "1px solid #d8d7d6",
              backgroundColor: "#F6F5F4 !Important",
              "& span": {
                pl: 2,
              },
              "&:not(:first-of-type) span": {
                borderLeft: "1px solid #d8d7d6",
              },
            },
            "& td": {
              px: 2,
              py: 3,
              verticalAlign: "top",
            },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="caption" color="text.primary">
                    判定
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.primary">
                    総合判定
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((d, i) => (
                <TableRow key={i}>
                  <TableCell>
                    <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                      {d.judge}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{d.description}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="caption" color="error.main">
          ※[E判定]は受診勧奨オプションありの場合のみ表示されます。
        </Typography>
        <Stack>
          <Typography variant="subtitle2">判定に※がついている場合：</Typography>
          <Typography variant="body2">
            睡眠に関して治療中であることを示します。かかりつけ医のもとで治療を継続しましょう。本測定は日常的に良質な睡眠がとれているかを判定しているため、あくまで参考情報となります。
          </Typography>
        </Stack>
      </Stack>
    </HelpDialogLayout>
  );
}

export default function JudgementCriteriaDialogButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <HelpDialogButton onClick={() => setOpen(true)}>
        判定基準
      </HelpDialogButton>
      <JudgementCriteriaDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
